import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Application } from './types';

const initialState: Application = {
  appId: '',
  name: '',
  privateKey: '',
  callbackUrl: '',
  projectName: '',
  appImageExists: false,
  createdAt: '',
  updatedAt: '',
  creatorEmail: '',
  appType: undefined,
  appPlatform: '',
  appImageUrl: '',
  redirectUrl: '',
  httpProvider: [],
};

const appDetailsSlice = createSlice({
  name: 'appDetails',
  initialState,
  reducers: {
    // set only partial state
    updateAppDetails(state, action: PayloadAction<Partial<Application>>) {
      Object.assign(state, action.payload);
    },
    resetAppDetails() {
      return { ...initialState };
    },
  },
});

export const { updateAppDetails, resetAppDetails } = appDetailsSlice.actions;

export default appDetailsSlice.reducer;
